
import React from "react";
import appInPhone from "../../assets/img/app-in-phones.png";
import StoreBadge from "@/components/common/info/StoreBadges";



export default function DownloadPage() {
    return (
        <div className="main">
            <div className="container-fluid -appPromotion">
                <div className="-bgColor" />
                <div className="container -appPromotion-jumbotron">
                    <div className="row">
                        <div className="col-md-6 col-12 -messages">
                            <h1>FurtherPass App</h1>
                            <div className="-appPromotion-subText">
                                FurtherPass makes traveling the easiest for you in today's conditions, collects your travel documents
                                and what needs to be done before on a single platform.
                            </div>
                            <div className="col-md-9">
                                <StoreBadge />
                            </div>
                        </div>
                        <div className="col-md-6 col-12 -heroImageContainer">
                            <img src={appInPhone} alt="App in Phone" className="-heroImage" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="container-fluid -appScreenShots">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            &nbsp;
                        </div>
                    </div>
                </div>
            </div>
            <div className="container-fluid -appVideo">
                <div className="container">
                    <div className="row">
                        <div className="col-12 -appVideoContainer">
                            <iframe
                                className="video"
                                src="https://www.youtube.com/embed/wH83q4F8tpw"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                                title="FurtherPass"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="container-fluid -appDownloadBadges">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <StoreBadge />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

